export const appendItemToArray = <T>(array: T[], item: T): T[] => [
  ...array,
  item,
];

export const removeItemFromArray = <T>(array: T[], item: T): T[] => {
  const index = array.indexOf(item);
  if (index < 0) {
    return array;
  }

  return [...array.slice(0, index), ...array.slice(index + 1)];
};
